import React from 'react';
import PropTypes from 'prop-types';
import './SaveSuccessDialog.css';

const SaveSuccessDialog = ({ show, onClose }) => {
  if (!show) return null;

  return (
    <div className="save-success-overlay">
      <button type="button" className="save-success-overlay-btn" onClick={onClose} aria-label="Dialog schließen" />
      <dialog className="save-success-dialog" open aria-label="Speichern erfolgreich">
        <div className="save-success-icon">
          <i className="bi bi-check-circle-fill"></i>
        </div>
        <h5 className="save-success-title">Erfolgreich gespeichert!</h5>
        <p className="save-success-text">
          Das Diagramm wurde erfolgreich gespeichert.
        </p>
        <button className="btn save-success-btn" onClick={onClose}>
          OK
        </button>
      </dialog>
    </div>
  );
};

SaveSuccessDialog.propTypes = {
  show: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
};

export default SaveSuccessDialog;
